import PaginatedListSerializer from 'lumen/serializers/paginated-list';

export default class SubscriptionUserSerializer extends PaginatedListSerializer {
  protected payloadModelName = 'subscription-users';
  primaryKey = 'user_id';
}
